import { Row, Col, Popover, Button, Avatar } from 'antd'
import moment from 'moment'
import { UserOutlined } from '@ant-design/icons'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import BBDLogo from '@assets/Logos/bbd-logo.svg'
import { OrderRequestType } from './OrderColumn'
import { FieldTimeOutlined } from '@ant-design/icons'

const iconStyles = {
  width: 24,
  height: 24,
}

export const OrderUpdatedTag = ({ setAuditOrderId, order, viewHistoryLabel }) => {
  const showModelGen = !order.created_by && !order.updated_by
  const hasBeenUpdated = !!order.updated_on
  const date =
    order.type === 'Order Request (Requested)'
      ? order.created_date
      : hasBeenUpdated
        ? order.updated_on
        : order.created_date

  return (
    <Popover
      content={<UpdateStatusDrawer order={order} />}
      title={<UpdateTitle order={order} setAuditOrderId={setAuditOrderId} label={viewHistoryLabel} />}
      trigger='hover'
      placement='leftTop'
    >
      <div>
        <Horizontal className='order-stat-tag-container' style={{ flexWrap: 'nowrap', minWidth: 'fit-content' }}>
          {showModelGen ? (
            <Vertical
              verticalCenter
              borderRadius='6px 0 0 6px'
              flex='0'
              style={{ overflow: 'visible', height: 20, background: 'var(--theme-color-2)' }}
            >
              <img className='p-1' src={BBDLogo} style={iconStyles} />
            </Vertical>
          ) : (
            <Vertical
              verticalCenter
              bg='info'
              border='all'
              borderRadius='6px 0 0 6px'
              flex='0'
              style={{ overflow: 'visible', height: 20 }}
            >
              <Texto category='label' appearance='secondary' weight='600' style={{ fontSize: '12px' }}>
                <UserOutlined className='px-2 py-2' />
              </Texto>
            </Vertical>
          )}

          <Vertical
            bg='elevated'
            border='all'
            borderRadius='0 6px 6px 0'
            flex={1}
            style={{ height: 20 }}
            className=' px-2 vertical-flex-center h-100'
          >
            <Texto category='label' style={{ fontWeight: hasBeenUpdated ? 'bold' : 'normal', flexWrap: 'nowrap' }}>
              {formatters.SHORT_DATE_TIME(moment(date))}
            </Texto>
          </Vertical>
        </Horizontal>
      </div>
    </Popover>
  )
}
export const UpdateStatusDrawer = ({ order, ignoreCreatedIfNull = false }) => {
  return (
    <div style={{ minWidth: 300 }}>
      {ignoreCreatedIfNull && !order.created_by ? null : (
        <Horizontal>
          <Vertical flex={2} gap='4px'>
            <Texto category='label' weight='600' className='popover-subtitle'>
              Created By
            </Texto>
            <Row className='popover-icon' align='top'>
              {!order.created_by ? (
                <Avatar size={24} style={{ overflow: 'visible', background: 'var(--theme-color-2)' }}>
                  <img src={BBDLogo} />
                </Avatar>
              ) : (
                <Avatar
                  size={24}
                  style={{
                    overflow: 'visible',
                    background: 'var(--theme-color-2-dim)',
                    color: 'var(--theme-color-1)',
                    border: 'solid 1px var(--gray-300)',
                  }}
                >
                  <UserOutlined />
                </Avatar>
              )}
              <Texto category='p1' className='popover-status-text'>
                {order.created_by ? order.created_by : 'Gravitate'}
              </Texto>
            </Row>
          </Vertical>
          <Vertical style={{ overflow: 'visible' }} gap='4px' flex={1} alignItems='flex-end'>
            <Texto className='popover-subtitle' category='label' weight='600'>
              At
            </Texto>
            <Texto style={{ whiteSpace: 'nowrap' }} category='p1' className='popover-status-text pl-2'>
              {order?.created_date ? formatters.WEEKDAY_MONTH_DATE_TIME(moment(order.created_date)) : ''}
            </Texto>
          </Vertical>
        </Horizontal>
      )}
      {(order.updated_by || order?.updated_date) && (
        <Horizontal>
          <Vertical gap='4px' flex={2} style={{ overflow: 'visible' }}>
            <Texto category='label' weight='600' className='popover-subtitle'>
              Last Updated By
            </Texto>
            <Row className='popover-icon' align='top'>
              <Avatar
                size={24}
                style={{
                  overflow: 'visible',
                  background: 'var(--theme-color-2-dim)',
                  color: 'var(--theme-color-1)',
                  border: 'solid 1px var(--gray-300)',
                }}
              >
                <UserOutlined />
              </Avatar>
              <Texto category='p1' className='popover-status-text'>
                {Array.isArray(order.updated_by) ? order.updated_by[order.updated_by.length - 1] : order.updated_by}
              </Texto>
            </Row>
          </Vertical>

          <Vertical gap='4px' flex={1} alignItems='flex-end' style={{ overflow: 'visible' }}>
            <Texto category='label' className='popover-subtitle' weight='600'>
              At
            </Texto>
            <Texto style={{ whiteSpace: 'nowrap' }} category='p1' className='popover-status-text pl-2'>
              {order?.created_date
                ? formatters.WEEKDAY_MONTH_DATE_TIME(moment(order.updated_on || order.updated_date))
                : ''}
            </Texto>
          </Vertical>
        </Horizontal>
      )}
    </div>
  )
}

const UpdateTitle = ({ setAuditOrderId, order, label = 'View Order History' }) => {
  const { scopes } = useSecurityContext()
  const orderScopes = ['o.r', 'o.w']
  const showAuditHistory = !scopes?.is_carrier && scopes.scopes.some((scope) => orderScopes.indexOf(scope) >= 0)

  return (
    <Horizontal verticalCenter>
      <Col flex={1}>
        <div className='popover-title'>Order History</div>
      </Col>

      {showAuditHistory && order.type !== OrderRequestType.OrderRequestRequested && (
        <Col>
          {setAuditOrderId && (
            <Button type='link' icon={<FieldTimeOutlined />} onClick={() => setAuditOrderId(order.id)}>
              {label}
            </Button>
          )}
        </Col>
      )}
    </Horizontal>
  )
}
